<div class="container">
  <app-file-preview [extension]="extension"></app-file-preview>
  <div class="file-upload">
    <div class="header">
      <span class="file-name"
      data-cy="upload-progress-file-name">{{file.name}}</span>
      <div class="retry">
        @if (uploadFailed) {
          <span (click)="retryClick(file)"
            data-cy="upload-progress-retry-button">
            <span class="iwp-icon-gen_repeat"></span>Retry</span>
          }
        </div>
        @if (showDownloadButton) {
          <div class="download"
            [ngClass]="{'completed': showDownloadButton, 'isPrevious': isPrevious, 'disableButton': disableButtons()}"
            (click)="download(file.name)"
            data-cy="upload-progress-download-button">
            <span data-cy="upload-progress-download-button-icon" class="iwp-icon-gen_download"></span>
            <span data-cy="upload-progress-download-button-label">Download</span>
            @if (isDownloading) {
              <app-loading-spinner class="button-spinner"
                data-cy="upload-progress-download-spinner"
              ></app-loading-spinner>
            }
          </div>
        }

        <app-tooltip [message]="deleteIconTooltip" [dynamic]="false">
          @if (deletePermissions) {
            <span [ngClass]="{'disableButton': disableButtonsDelete()}"
              class="iwp-icon-gen_close_s"
              (click)="openOverlay(true)"
            data-cy="upload-progress-delete-button"></span>
          }
        </app-tooltip>
      </div>
      <div class="progress">
        <div class="progress-bar {{progressStatus}}" [style.width]="progress + '%'"></div>
      </div>
      <div class="footer">
        <span class="progress-percentage"
        data-cy="upload-progress-progress-loaded">{{loaded}} KB of {{total}} KB</span>
        @if (!isPrevious) {
          <span class="progress-status {{progressStatus}}"
            [ngClass]="{'completed': showDownloadButton}"
          data-cy="upload-progress-progress-status">{{message}}</span>
          }@if (icon) {
          <span
            class="icon {{icon}} {{progressStatus}}"
          data-cy="upload-progress-progress-status-icon"></span>
        }
      </div>
    </div>

    <div>
      @if (showOverlay) {
        <app-generic-overlay
          [isSpinner]="isDeletingSpinner()"
          [firstButtonEnabled]="!isDeletingSpinner()"
          [secondButtonEnabled]="!isDeletingSpinner()"
          (firstButtonEvent)="closeOverlay()"
          (secondButtonEvent)="deleteClick(file)">
        </app-generic-overlay>
      }
    </div>
  </div>

